/** @format */

import { z } from "zod";

export const editResultSchema = z.object({
  pointsPenalty: z.number().min(0, "Points penalty must be greater than or equal to 0"),
  cucumbered: z.boolean(),
  disqualified: z.boolean(),
  waiverType: z.enum(["none", "approved", "unapproved", "oep"]),
});

export type EditResultFormData = z.infer<typeof editResultSchema>;
